import App from "./App.jsx";
import { AuthProvider } from "oidc-react";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { GetTenantId } from "./utils/helpers";
import { oidcConfig } from "./config/oidcConfig";
import { IconLoading } from "./components/Loading/IconLoading.jsx";
import useValidateSubscription from "./hooks/useValidateSubscription";
const AppAuth = () => {
  const hasTenantId = GetTenantId() !== null;
  const [isLoggedIn, setIsLoggedIn] = useState(hasTenantId);
  const [token, setToken] = useState(null);
  const { i18n } = useTranslation();
  const lang = sessionStorage.getItem("lang");

  const prodId = import.meta.env.PUBLIC_DUEDATES_PRODUCT_ID;
  const hasValidSubscription = useValidateSubscription(token, prodId);

  useEffect(() => {
    if (token !== null) {
      sessionStorage.setItem("valid_sub", hasValidSubscription);
    }
  }, [hasValidSubscription, token]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const boardId = params.get("boardId");
    const open = params.get("open");

    if (boardId) {
      sessionStorage.setItem("boardId", boardId || "");
    }

    if (open) {
      sessionStorage.setItem("open", open || "");
    }
  }, []);

  const onSignIn = (userData) => {
    const userToken = userData.access_token;
    setToken(userToken);

    sessionStorage.setItem("token", userData.access_token);
    sessionStorage.setItem("expires_at", userData.expires_at);
    sessionStorage.setItem("tenant_id", userData.profile.tenant_id);
    sessionStorage.setItem("refresh_token", userData.refresh_token);

    if (lang) {
      i18n.changeLanguage(lang);
    } else {
      sessionStorage.setItem("lang", i18n.language);
    }

    setIsLoggedIn(true);
  };

  return (
    <AuthProvider {...oidcConfig} onSignIn={onSignIn}>
      {isLoggedIn ? <App /> : <IconLoading />}
    </AuthProvider>
  );
};

export default AppAuth;
